import React, { createContext, useContext, useState, useEffect } from 'react';
import { usePlayerContext } from '../Context';
import { CurrentTimeEvents } from '../../sdk/PlayerEvents';
import { Events, State } from '../../types/player';
import Utils from '../../utils/Utils';

const TimeInfo = () => {
  const { sdk } = usePlayerContext();

  const [currentTime, setCurrentTime] = useState(
    sdk.getCurrentTime() as number,
  );
  const [duration, setCurrentDuration] = useState(sdk.getDuration() as number);
  let listeners: (() => void)[] = [];

  let currentDuration = duration;

  useEffect(() => {
    listeners.push(
      sdk.on(Events.CURRENT_TIME, (data: CurrentTimeEvents) => {
        if (currentDuration != data.duration && !Number.isNaN(data.duration)) {
          currentDuration = data.duration;
          setCurrentDuration(data.duration);
        }
        setCurrentTime(data.currentTime);
      }),
    );
    return () => {
      listeners.forEach((listener) => listener());
    };
  }, []);

  function getTimeInfoLabel() {
    //TODO: add a hook here to be able to bypass this formatting
    const showHours = duration >= 3600;

    let current = sdk.isDvr()
      ? `- ${Utils.convertTimeInSecondsToTimeLabel(duration - currentTime, showHours)} `
      : `${Utils.convertTimeInSecondsToTimeLabel(currentTime, showHours)} `;
    return (
      <>
        {current}
        <span
          className={`${sdk.getClassNamePrefix()}-player-control-time-info-sep`}
        >
          /
        </span>
        {Utils.convertTimeInSecondsToTimeLabel(duration, showHours)}
      </>
    );
  }

  return (
    <div
      className={`${sdk.getClassNamePrefix()}-player-control ${sdk.getClassNamePrefix()}-player-control-time-info`}
    >
      {getTimeInfoLabel()}
    </div>
  );
};

export default TimeInfo;
